import type { EditFixtureForm, FixtureEntityUpsert, FixtureEntrantTransformed, FixturePersonUpsert } from "~pages/Fixtures/types";
import { getIsScoreEqual } from "./getIsScoreEqual";
import { getScoreSubmitData } from "./getScoreSubmitData";

type ReturnType = {
  competitors: FixtureEntityUpsert[];
  participants: FixturePersonUpsert[];
};

export const getEntrantsSubmitData = (values: EditFixtureForm): ReturnType => {
  const { awayResultPlace, awayResultSecondaryScorePlace, draw, homeResultPlace, homeResultSecondaryScorePlace } = getScoreSubmitData({
    awayScore: values.awayScore,
    awaySecondaryScore: values.awaySecondaryScore,
    homeScore: values.homeScore,
    homeSecondaryScore: values.homeSecondaryScore,
  });

  // The secondary score only decides the result when the main score is tied
  const isScoreEqual = getIsScoreEqual(values.homeScore, values.awayScore);

  const getEntrantCommonPayload = (entrant: FixtureEntrantTransformed) => ({
    draw,
    resultPlace: entrant.isHome ? homeResultPlace : awayResultPlace,
    includeInRepresentation: entrant.includeInRepresentation,
    resultSecondaryScorePlace: entrant.isHome ? homeResultSecondaryScorePlace : awayResultSecondaryScorePlace,
    score: (entrant.isHome ? values.homeScore : values.awayScore) || null,
    secondaryScore: (isScoreEqual && (entrant.isHome ? values.homeSecondaryScore : values.awaySecondaryScore)) || null,
    isNeutralVenue: values.isNeutralVenue,
    externalId: entrant.externalId || null,
    resultStatus: entrant.resultStatus,
    uniformId: entrant.uniform?.value || null,
  });

  return {
    competitors: (values.competitors ?? []).map((entity) => ({
      ...getEntrantCommonPayload(entity),
      entityId: entity.entityId,
      includeInConferenceStatistics: values.includeInConferenceStatistics,
    })),
    participants: (values.participants ?? []).map((participant) => ({
      ...getEntrantCommonPayload(participant),
      personId: participant.personId,
    })),
  };
};
